module.exports = __webpack_public_path__ + "static/img/far3_active.6d31790f.png";